import {all, call, fork, put, takeEvery} from 'redux-saga/effects'
import {
  JobsActionTypes, deleteError, deleteSuccess, fetchError, fetchSuccess, createError, createSuccess,
  updateSuccess, updateError, fetchItemSuccess, fetchItemError
} from '@actions/job';
import {updateSuccess as updateCurrentJob} from '@actions/auth';
import jobApi from '@api/job';
import {ReduxAction} from "@actions/index";


function* handleFetch({payload}: ReduxAction) {
  try {
    const res = yield call(jobApi.getList, payload);
    yield put(fetchSuccess(res))
  } catch (err) {
    yield put(fetchError(err))
  }
}


function* handleDelete({payload}: ReduxAction) {
  try {
    yield call(jobApi.delete, payload);
    yield put(deleteSuccess(payload.params));
  } catch (err) {
    yield put(deleteError(err))
  }
}


function* handleCreate({payload}: ReduxAction) {
  try {
    const {data} = yield call(jobApi.create, payload);
    payload.onSuccessCallback && payload.onSuccessCallback(data);
    yield put(createSuccess(data))
  } catch (err) {
    yield put(createError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}

function* handleUpdate({payload}: ReduxAction) {
  try {
    const {data} = yield call(jobApi.update, payload);
    payload.onSuccessCallback && payload.onSuccessCallback();
    yield put(updateSuccess(data));
    // For updating current job info in header :
    yield put(updateCurrentJob(data));
  } catch (err) {
    yield put(updateError(err));
    payload.onErrorCallback && payload.onErrorCallback(err);
  }
}


// We can also use `fork()` here to split our saga into multiple watchers.
function* jobsSaga() {
  yield all([
    yield takeEvery(JobsActionTypes.FETCH_REQUEST, handleFetch),
    yield takeEvery(JobsActionTypes.DELETE_REQUEST, handleDelete),
    yield takeEvery(JobsActionTypes.CREATE_REQUEST, handleCreate),
    yield takeEvery(JobsActionTypes.UPDATE_REQUEST, handleUpdate),
  ])
}

export default jobsSaga
